import { createContext, useContext } from "react";

export const BookNavigationContext = createContext<string | undefined>(undefined);

export const useBookRootPath = () => useContext(BookNavigationContext);
